import { Navigate, Route, Routes } from 'react-router-dom'
import BoxTruckZipAnalyticsPage from './BoxTruckZipAnalyticsPage'

export default function BoxTruckZipAnalyticsRoutes() {
    return (
        <Routes>
            <Route index element={<BoxTruckZipAnalyticsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
